import * as Sentry from '@sentry/react'

export const catchWithSentry = (e: any) => {
  // A network failure has no `data` at all — reading through it threw inside
  // the catch handler itself, turning a handled error into a crash.
  if (e?.data?.statusCode === 500) {
    Sentry.captureException(e)
  }
}
